import React from "react";
import { Image } from "@shared/components/Image";

export const imgMapper = (
  props: React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >
) => {
  return <Image {...props} errorMessage="Image not provided" />;
};
